import { memo, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { isNullOrEmpty } from "../../../Utils/stringUtils";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import Button from "../Button/Button";
import "./modal.scss";

const BasicModal = memo(
  ({
    show,
    handleClose,
    cancelText,
    heading,
    children,
    footer,
    button1Text,
    button1Click,
    button2Text,
    button2Click,
    button3Text,
    button3Click,
    button4Text,
    button4Click,
    button5Text,
    button5Click,
    size,
    formID,
    minH,
    maxH,
    loading,
    loading2,
    headingBtn,
    isDisabled,
    modalZIndex,
    button1Danger,
  }) => {
    const modalBodyRef = useRef(null);
    const [hasScroll, setHasScroll] = useState(false);

    useEffect(() => {
      if (modalBodyRef.current) {
        const hasVerticalScrollbar =
          modalBodyRef.current.scrollHeight > modalBodyRef.current.clientHeight;
        setHasScroll(hasVerticalScrollbar);
      }
      if (typeof window !== "undefined" && formID) {
        window.dispatchEvent(
          new CustomEvent("bharat-modal-state-change", {
            detail: { formID, show: Boolean(show) },
          }),
        );
      }
    }, [show, formID]);

    const handleScrollToBottom = () => {
      if (modalBodyRef.current) {
        const scrollHeight = modalBodyRef.current.scrollHeight;
        const clientHeight = modalBodyRef.current.clientHeight;
        const maxScrollTop = scrollHeight - clientHeight;
        modalBodyRef.current.scrollTo({
          top: maxScrollTop,
          behavior: "smooth",
        });
      }
      setHasScroll(false);
    };

    return (
      <Modal
        style={{ zIndex: modalZIndex !== undefined ? modalZIndex : "" }}
        backdrop="static"
        centered
        size={size}
        show={!!show}
        onHide={handleClose}
      >
        <Modal.Header closeButton className="d-flex align-items-center">
          <Modal.Title className="m-0 flex-grow-1">{heading}</Modal.Title>
          {headingBtn && <div className="modal-header-actions">{headingBtn}</div>}
        </Modal.Header>
        <Modal.Body
          style={{
            minHeight: minH,
            maxHeight: maxH,
            zIndex: modalZIndex !== undefined ? modalZIndex : 9999,
          }}
          ref={modalBodyRef}
        >
          {children}
        </Modal.Body>
        {footer ? (
          <Modal.Footer>
            <div className="d-flex w-100 justify-content-between flex-wrap">
              <div className="mb-2">
                {!isNullOrEmpty(button4Text) && button4Click ? (
                  <Button
                    disabled={isDisabled}
                    buttonType="primary"
                    text={button4Text}
                    onClick={button4Click}
                    for={formID}
                    type="submit"
                    isLoading={loading2 ? loading2 : loading ? loading : null}
                  />
                ) : null}
              </div>
              <div
                id="tour-modal-footer-actions"
                className="d-flex flex-wrap gap-2 justify-content-sm-start justify-content-center"
              >
                {handleClose ? (
                  <Button
                    className="flex-grow-1 flex-sm-grow-0 btn emr-btn__secondary"
                    buttonType="secondary"
                    text={cancelText || "Cancel"}
                    onClick={handleClose}
                  />
                ) : null}

                {button1Click ? (
                  <Button
                    className={`flex-grow-1 flex-sm-grow-0 btn emr-btn__primary ${
                      button1Danger ? "emr-btn__danger-solid" : ""
                    }`}
                    disabled={isDisabled && button1Text !== "Preview Prescription"}
                    buttonType="primary"
                    text={button1Text}
                    onClick={button1Click}
                    for={formID}
                    type="submit"
                    isLoading={loading}
                  />
                ) : null}

                {button2Click ? (
                  <Button
                    className="flex-grow-1 flex-sm-grow-0 btn emr-btn__primary"
                    disabled={isDisabled}
                    buttonType="primary"
                    text={button2Text}
                    onClick={button2Click}
                    for={formID}
                    type="submit"
                    isLoading={loading2 ? loading2 : loading ? loading : null}
                  />
                ) : null}

                {button3Click ? (
                  <Button
                    className="flex-grow-1 flex-sm-grow-0 btn emr-btn__primary"
                    disabled={isDisabled}
                    buttonType="primary"
                    text={button3Text}
                    onClick={button3Click}
                    for={formID}
                    type="submit"
                    isLoading={loading2 ? loading2 : loading ? loading : null}
                  />
                ) : null}
                {button5Click ? (
                  <Button
                    disabled={isDisabled}
                    buttonType="primary"
                    text={button5Text}
                    onClick={button5Click}
                    for={formID}
                    type="submit"
                    isLoading={loading2 ? loading2 : loading ? loading : null}
                  />
                ) : null}
              </div>
            </div>

            {hasScroll ? (
              <div className="scroll_down" style={{ zIndex: 100 }}>
                <Button
                  onClick={handleScrollToBottom}
                  buttonType="icon"
                  icon={<IconResource type="arrowDown" color="var(--primary)" />}
                />
              </div>
            ) : null}
          </Modal.Footer>
        ) : (
          ""
        )}
      </Modal>
    );
  },
);

export default BasicModal;
